import { Box } from '@chakra-ui/react';
import React, { useState, useEffect, useCallback } from 'react';

import { useGetLimitedPartnerMappingsForAliasingLazyQueryGQLType } from 'types/dashboard-core-gqlTypes.generated.d';

import { AliasMatchingFilters } from './AliasMatchingFilters';
import { AliasMatchingTablesContainer } from './AliasMatchingTable';
import { MatchStatusCardsContainer } from './MatchStatusCards';
import { MatchStatus } from './types';
import { Typography } from 'packages/common-frontend/components/Typography';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Breadcrumbs } from '~/packages/common-frontend/components/Breadcrumbs';
import { dashboardRoutePadding } from '~/packages/common-frontend/constants';

export const AliasMatching = () => {
  const { user } = useUserAuthOrThrow();

  const [
    getLimitedPartnerMappingsForAliasing,
    { data: aliasingData, error: aliasingDataError },
  ] = useGetLimitedPartnerMappingsForAliasingLazyQueryGQLType({
    fetchPolicy: 'cache-and-network',
  });

  if (aliasingDataError) throw aliasingDataError;

  const [matchStatusForTables, setMatchStatusForTables] = useState<MatchStatus>(
    'all',
  );

  const [searchQuery, setSearchQuery] = useState('');

  const refetchMappingsForAliasing = useCallback(() => {
    getLimitedPartnerMappingsForAliasing({
      variables: {
        lenderOrganizationId: user.organizationId,
        queryString: searchQuery,
      },
    });
  }, [getLimitedPartnerMappingsForAliasing, user.organizationId, searchQuery]);

  useEffect(() => {
    refetchMappingsForAliasing();
  }, [refetchMappingsForAliasing]);

  return (
    <Box padding={dashboardRoutePadding}>
      <Breadcrumbs
        breadcrumbs={[{ label: 'Limited Partners', path: `/limited-partners` }]}
      />
      <Typography variant="page-title" TextProps={{ mt: '1.5rem' }}>
        Match LP Alias
      </Typography>
      <MatchStatusCardsContainer
        aliasingData={aliasingData}
        matchStatusForTables={matchStatusForTables}
        setMatchStatusForTables={setMatchStatusForTables}
      />
      <AliasMatchingFilters setSearchQuery={setSearchQuery} />
      <AliasMatchingTablesContainer
        aliasingData={aliasingData}
        lenderOrganizationId={user.organizationId}
        refetchMappingsForAliasing={refetchMappingsForAliasing}
        matchStatusForTables={matchStatusForTables}
      />
    </Box>
  );
};
